<template>
    <v-app>
        <scale
            :model_score="lighting_score" 
            :model_comment="lighting_comment" 
            :section="section" 
            :contents="contents"
            :title="title"
        ></scale>
    </v-app>
</template>
<script>
import db from '@/components/firebase.init';
import Scale from '@/components/Scale';
export default {
    props:['section'],
    data(){
        return{
            lighting_score: [],
            lighting_comment: [],
            na: 0,
            title: "Lighting",
            contents:[
                {
                    question: "Are overhead lights positioned that they do not create shadows on the workstation?",
                    parts: ['General']
                },
                {
                    question: "Is there workstation oriented at 90 degree from window?",
                    parts: ['General']
                },
                {
                    question: "Are there any curtains/blinds to reduce glare from windows?",
                    parts: ['General']
                },
                {
                    question: "Is the workstation between rows of overhead lights?",
                    parts: ['General']
                },
            ]
        }
    },
    methods:{
        getTotalScore(){
            let total = 0;
            this.na = 0;
            for(var x = 0; x < this.lighting_score.length; x++){
                if(this.lighting_score[x] == 'NA'){
                    this.na++;
                }
                else{
                    total += this.lighting_score[x]
                }
            }
            
            return total;
        },
        getTotalNa(){
            return this.na;
        },
        invalid(){
            return this.lighting_score.length != this.contents.length || this.lighting_score.includes(undefined);
        },
        submit(id){
            let score = this.getTotalScore();
            db.collection('forms').doc(id).update(
                {
                    lighting_score: this.lighting_score,
                    lighting_comment: this.lighting_comment,
                    lighting_total: score
                }
            ).then(data=>{
                
            })
            .catch(e =>{
                alert(e);
            })
        },
        initializeComment(){
            for(var i = 0; i < this.contents.length; i++){
                this.lighting_comment[i] = "";
            }
        }
    },
    components:{
        'scale' : Scale
    },
    mounted(){
        this.initializeComment();
    }
}
</script>

